import { CustomField } from "@/app/components/form-fields/atoms";
import { FormDate } from "@/app/components/FormDate";
import { Entity, IDateField } from "@/app/fields/types";

export const DateFormField = <T extends Entity>({
  field,
  isDisabled,
}: {
  field: IDateField<T>;
  isDisabled?: boolean;
}) => {
  return (
    <CustomField
      field={field}
      isDisabled={isDisabled}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormDate
          isDisabled={isDisabled}
          isRequired={field.is_required}
          name={String(field.field)}
          onChange={onChange}
          value={value}
        />
      )}
    />
  );
};
